.periods__container {
  display: flex;
  flex-wrap: nowrap;
}

.periods__item {
  background-color: var(--color-grey-400);
  border: 1px solid var(--color-grey-500);
  display: inline-block;
  height: 0.75rem;
  margin-right: 0.125rem;
  width: 0.5rem;
}

.periods__item:last-child {
  margin-right: 0;
}

.periods__item:nth-child(3n):not(:last-child) {
  margin-right: 0.5rem;
}

.periods__item--active {
  background-color: var(--color-grey-600);
  border: unset;
}
